import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=2ed5db71&"
import script from "./IconList.vue?vue&type=script&lang=ts&"
export * from "./IconList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports